var error = {
  translation: {
    error: {
      coreNotFound: '코어 설정을 가져오지 못했습니다',
      domainNotAllowed: '이 도메인의 이메일로는 가입 불가',
      emailAlreadyInUse: '이미 사용 중인 이메일',
      insufficientPermissions: '권한 부족',
      invalidCurrentPassword: '현재 비밀번호 틀림',
      invalidPermissions: '적어도 하나의 권한을 선택하세요',
      invalidUsernameOrPassword: '잘못된 사용자 이름 또는 비밀번호',
      localRegistrationDisabled: '로컬 사용자 등록이 관리자에 의해 비활성화됨',
      noInternetConnection: '인터넷 연결 없음',
      noOidcProfileFound: 'OIDC 프로필 없음',
      policyNotAccepted: '이용약관 및 개인정보처리방침에 동의해 주세요',
      registrationDisabled: '사용자 등록이 관리자에 의해 비활성화됨',
      serverConnectionFailed: '서버 연결 실패',
      ssoRegistrationDisabled: 'SSO 등록이 관리자에 의해 비활성화됨',
      tooManyFailedAttempts: '실패한 시도가 너무 많습니다 - 나중에 다시 시도하세요',
      unknownError: '알 수 없는 오류, 나중에 다시 시도하세요',
      usernameAlreadyInUse: '이미 사용 중인 이름',
      weakPassword: '더 강한 비밀번호 사용',
    },
  },
};

export { error as default };
